import { Grid, Typography } from '@mui/material';
import React from 'react';

import { PageLoadingProps } from './types';

export default function PageLoading(props: PageLoadingProps) {
    const { classes } = props;

    return (
        <Grid
            alignItems='center'
            className={classes.root}
            container
            direction='column'
            justifyContent='center'
        >
            <div className={classes.loader} />
            <Typography variant='body1'>Page Loading...</Typography>
        </Grid>
    );
}